import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { ToolbarItemProps } from "../../Grid/Toolbar/ToolbarItems";

interface Props {
  onClick: () => void;
  roles?: string[];
}

export const contactUploadButton = ({
  onClick,
  text = "Contact Upload",
  icon = faUpload,
  roles = [],
}: Props & Partial<ToolbarItemProps>) => ({
  text,
  icon,
  onClick,
  roles,
});
